var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    [
      _c("vs-col", { attrs: { "vs-w": "12" } }, [
        _c("h3", [_vm._v(" Mantenedor de Instituciones ")]),
        _c("div", { staticClass: "margin-top" }, [
          _c("br"),
          _vm._v(
            "Estas opciones activas aparecerán en los formularios de la aplicación. "
          )
        ]),
        _vm.mantenedorInstitutions && !_vm.mantenedorInstitutions.length
          ? _c("div", [
              _c("h4", { staticClass: "info-documents" }, [
                _vm._v(" Pulsa el botón "),
                _c(
                  "span",
                  { staticStyle: { padding: "0 4px" } },
                  [
                    _c("vs-button", {
                      staticClass: "margin-right",
                      attrs: {
                        color: "primary",
                        size: "small",
                        disabled: "",
                        type: "border",
                        icon: "search"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" para ver las instituciones de la categoría ")
              ])
            ])
          : _vm._e()
      ]),
      _c(
        "vs-col",
        { attrs: { "vs-lg": "12", id: "listado-opciones" } },
        [
          _c(
            "vs-row",
            {
              attrs: {
                "vs-type": "flex",
                "vs-align": "space-around",
                "vs-justify": "space-around"
              }
            },
            [
              _c(
                "vs-col",
                {
                  staticClass: "margin-top",
                  attrs: { "vs-sm": "12", "vs-lg": "6" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "add-new" },
                    [
                      _c("h4", [_vm._v("Tipos de instituciones")]),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED028" } },
                        [
                          _c("vs-button", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Agregar categoría",
                                expression: "'Agregar categoría'"
                              }
                            ],
                            staticClass: "margin-right",
                            attrs: {
                              color: "primary",
                              type: "border",
                              icon: "playlist_add",
                              "data-cy": "add-category"
                            },
                            on: {
                              click: function($event) {
                                return _vm.createOption()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-list",
                    { staticClass: "bg-white margin-top box-options" },
                    _vm._l(_vm.categoryInstitutions, function(category) {
                      return _c(
                        "div",
                        {
                          key: category.opcionId,
                          staticClass: "wrap-list-item",
                          attrs: { "data-cy": "institution" }
                        },
                        [
                          _c("ListItemOptionInstitution", {
                            attrs: {
                              option: category,
                              type: "category",
                              selectedCategory:
                                _vm.selectedInstitution &&
                                _vm.selectedInstitution.opcionId ===
                                  category.opcionId
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _c(
                "vs-col",
                {
                  staticClass: "margin-top",
                  attrs: { "vs-sm": "12", "vs-lg": "6" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "add-new" },
                    [
                      _c("h4", [_vm._v("Instituciones")]),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED031" } },
                        [
                          _vm.selectedInstitution.opcionId
                            ? _c("vs-button", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Agregar institución a categoría",
                                    expression:
                                      "'Agregar institución a categoría'"
                                  }
                                ],
                                staticClass: "margin-right",
                                attrs: {
                                  color: "primary",
                                  type: "border",
                                  icon: "playlist_add"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.createOption(
                                      _vm.selectedInstitution
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.mantenedorInstitutions &&
                  _vm.mantenedorInstitutions.length
                    ? _c(
                        "vs-list",
                        { staticClass: "bg-white margin-top box-options" },
                        _vm._l(_vm.mantenedorInstitutions, function(document) {
                          return _c(
                            "div",
                            {
                              key: document.opcionId,
                              staticClass: "wrap-list-item"
                            },
                            [
                              _c("ListItemOptionInstitution", {
                                attrs: {
                                  option: document,
                                  type: "document",
                                  institution: _vm.selectedInstitution
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.createDocument
              ? "Nueva Institución"
              : "Nuevo tipo de institución",
            "hide-footer": "",
            centered: ""
          },
          model: {
            value: _vm.createMood,
            callback: function($$v) {
              _vm.createMood = $$v
            },
            expression: "createMood"
          }
        },
        [
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.option.valor,
                  expression: "option.valor"
                }
              ],
              staticClass: "input-option input-edit",
              attrs: {
                maxlength: "10",
                placeholder: "Abreviación",
                size: "small",
                "data-cy": "abreviation"
              },
              domProps: { value: _vm.option.valor },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.option, "valor", $event.target.value)
                }
              }
            })
          ]),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.option.descripcion,
                  expression: "option.descripcion"
                }
              ],
              staticClass: "input-option input-edit",
              attrs: {
                maxlength: "100",
                placeholder: "Nombre de opción",
                size: "small",
                "data-cy": "description"
              },
              domProps: { value: _vm.option.descripcion },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.option, "descripcion", $event.target.value)
                }
              }
            })
          ]),
          _c(
            "div",
            { staticClass: "box-button" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "margin-top",
                  attrs: { color: "primary", type: "border", icon: "save" },
                  on: {
                    click: function($event) {
                      return _vm.saveOption()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }